import { useEffect, useRef, useState, type RefObject } from "react";

export function useStageViewport(
  stageRef: RefObject<HTMLDivElement | null>,
  cameraLockEnabled: boolean,
  hasRestoredView: boolean,
  resetToHome: () => void,
  skipInitialHomeReset = false,
): { width: number; height: number } {
  const [viewport, setViewport] = useState({ width: 1280, height: 800 });
  const didInitialHomeRef = useRef(false);

  useEffect(() => {
    const stage = stageRef.current;
    if (stage === null) {
      return;
    }
    const sync = (): void => {
      setViewport({
        width: Math.max(1, stage.clientWidth),
        height: Math.max(1, stage.clientHeight),
      });
    };
    sync();
    if (!didInitialHomeRef.current) {
      didInitialHomeRef.current = true;
      if (!skipInitialHomeReset && !cameraLockEnabled && !hasRestoredView) {
        resetToHome();
      }
    }
    const observer = new ResizeObserver(sync);
    observer.observe(stage);
    return () => observer.disconnect();
  }, [cameraLockEnabled, hasRestoredView, resetToHome, skipInitialHomeReset, stageRef]);

  return viewport;
}
